import { render, staticRenderFns } from "./DoctorNote.vue?vue&type=template&id=4cba94fc&"
import script from "./DoctorNote.vue?vue&type=script&lang=js&"
export * from "./DoctorNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/My Data/Codes/drdanielwai/drdanielwainew-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VIcon,VLayout,VSelect})
